<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="手机号码：" prop="cusPho">
            <el-input v-model="query.cusPho" placeholder="请输入手机号" size="small" />
          </el-form-item>
          <el-form-item label="客户手机号：" prop="keyword">
            <el-input v-model="query.keyword" placeholder="请输入手机号" size="small" />
          </el-form-item>
          <el-form-item label="建档时间：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="治疗师" prop="name" align="center" width="200">
          <template slot-scope="{row}">
            {{row.customerName}}{{row.customerLevel?'('+row.customerLevel+')':''}}<br />{{row.customerPho}}
          </template>
        </el-table-column>
        <el-table-column label="档案客户姓名" prop="name" align="center" />
        <el-table-column label="手机号" prop="pho" align="center" />
        <el-table-column label="性别" prop="sex" align="center" >
          <template slot-scope="{row}">
            {{row.sex === 1?'男':(row.sex === 2?'女':'')}}
          </template>
        </el-table-column>
        <el-table-column label="年龄" prop="age" align="center" />
        <el-table-column label="病名" prop="diseaseName" align="center" />
        <el-table-column label="建档时间" prop="createdTime" align="center">
          <template slot-scope="{row}">
            {{ formatTime(row.createdTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="130">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import userArchivesApi from '@/api/archives/userArchives'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      selectItems: [],
      dateTime: null
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.dateTime = []
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 分类筛选
     */
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = { ...this.query }
      query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      this.listLoading = true
      return userArchivesApi.fetchList(query)
        .then(({ data }) => {
          console.log("data: ", data);
          this.list = data.records
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => userStoreApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      return this.$common.confirm(`当前选择${this.selectItems.length}条数据，是否确认删除`)
        .then(() => userStoreApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 格式化时间，去掉T字符
     */
    formatTime(timeStr) {
      if (!timeStr) return ''
      return timeStr.replace('T', ' ')
    },
  }
}
</script>
